import React from "react";


export function EditUserContainer({ accessToken, name, email }) {
  return(
      <p>EditUser</p>
  )
}
 